import Default from "./default";
import { importHtmx } from "../helpers/sprig";

class Filters extends Default {
  namespace = "filters";

  beforeEnter = (data) => {
    super.beforeEnter(data);
    const { next } = data;
    importHtmx(next);
  };

  beforeLeave = (data) => {
    super.beforeLeave(data);
  };

  afterLeave = (data) => {
    super.afterLeave(data);
  };

  afterEnter = (data) => {
    super.afterEnter(data);
  };
}

export default new Filters();
